import { type BoxProps } from '@chakra-ui/react';
import { type ForwardedRef, forwardRef } from 'react';

import { type WistiaPlaybackRef, WistiaEmbedFromHtml } from './WistiaEmbedFromHtml';

type WistiaPlayerEmbedProps = Record<string, string | number | boolean | null | undefined>;

type WistiaEmbedProps = {
  embedHtml: string;
  playerProps?: WistiaPlayerEmbedProps;
} & BoxProps;

const WistiaEmbedComponent = (
  { embedHtml, playerProps, ...boxProps }: WistiaEmbedProps,
  ref: ForwardedRef<WistiaPlaybackRef | null>,
) => <WistiaEmbedFromHtml embedHtml={embedHtml} playerProps={playerProps} wistiaRef={ref} {...boxProps} />;

export const WistiaEmbed = forwardRef<WistiaPlaybackRef | null, WistiaEmbedProps>(WistiaEmbedComponent);
WistiaEmbed.displayName = 'WistiaEmbed';
